import { ChangeEventHandler, createContext } from 'react';

type InputContextType = {
  onChange: ChangeEventHandler<HTMLInputElement> | undefined;
};

export const InputContext = createContext<InputContextType>({
  onChange: undefined
});
